import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Row, Col, Input, Button, Table, Icon } from 'antd'

import './index.css'
import Logo from 'assets/images/ekko-logo.png'

import {
    validateSetupChannels,
    addChannelOnboarding,
    removeChannelOnboarding,
    prevStep
} from 'redux/OnBoardingNow/actions'

class StepTwo extends React.Component {
    state = {
        input: ''
    }

    columns = [
        { title: 'Topic Name', dataIndex: 'name', key: 'name' },
        {
            title: '',
            dataIndex: '',
            key: 'x',
            render: record => (
                <a>
                    <Icon type="close" onClick={() => this.handleDeleteChannel(record)} />
                </a>
            )
        }
    ]

    handleDeleteChannel = record => {
        const { removeChannel } = this.props

        removeChannel(record)
    }

    onChangeInput = e => {
        const { value } = e.target

        this.setState({
            input: value
        })
    }

    onCreateChannel = () => {
        const { addChannel } = this.props

        addChannel(this.state.input)
        this.setState({
            input: ''
        })
    }

    onPrev = () => {
        const { back } = this.props

        back()
    }

    onNext = () => {
        const { validateSetupChannels } = this.props
        validateSetupChannels()
    }

    render() {
        const { topics } = this.props

        return (
            <Col xs={22} sm={18} md={14}>
                <img src={Logo} height="42" />
                <h2 style={{ paddingTop: 50, marginBottom: 20 }}>Create some Topics.</h2>

                <div style={{ paddingTop: 30 }}>
                    <h5 style={{ color: 'inherit' }}>Max 5 Topics</h5>
                    <Row>
                        <Col span={14}>
                            <Input
                                placeholder="Topic name"
                                onChange={this.onChangeInput}
                                onPressEnter={this.onCreateChannel}
                                value={this.state.input}
                            ></Input>
                        </Col>
                        <Col span={6}>
                            <Button type="primary" onClick={this.onCreateChannel}>
                                Create
                            </Button>
                        </Col>
                    </Row>
                </div>

                <Table
                    rowKey={r => r.name}
                    columns={this.columns}
                    dataSource={topics}
                    pagination={false}
                    style={{ paddingTop: 20 }}
                />

                <div style={{ paddingTop: 40 }}>
                    <Row justify="space-between" type="flex">
                        <Button onClick={this.onPrev}>Prev</Button>
                        <Button type="primary" onClick={this.onNext}>
                            Next
                        </Button>
                    </Row>
                </div>
            </Col>
        )
    }
}

const mapStateToProps = ({ onboarding }) => ({
    topics: onboarding.channels
})

const mapActionsToProps = dispatch => ({
    back: bindActionCreators(prevStep, dispatch),
    addChannel: bindActionCreators(addChannelOnboarding, dispatch),
    removeChannel: bindActionCreators(removeChannelOnboarding, dispatch),
    validateSetupChannels: bindActionCreators(validateSetupChannels, dispatch)
})

export default connect(
    mapStateToProps,
    mapActionsToProps
)(StepTwo)
